import React from "react";
import Measure from "react-measure";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { Error, Loading, PanelContent } from "./index";
import PanelSegmentType from "./PanelSegment/PanelSegment";

interface IState {
  contentHeight?: number
  error: boolean
}

interface PanelProps {
  panelClassName?: string
  title?: string
  subTitle?: string | React.ReactNode
  button?: React.ReactNode
  pagination?: JSX.Element | React.ReactNode
  isLoading?: boolean
  hasError?: boolean
  hasData?: boolean
  contentCssClass?: string
  articleId?: number
  style?: React.CSSProperties
  headerContainerClasses?: string
  headerSize?: "h1" | "h2"
  panelRef?: React.RefObject<HTMLDivElement>
}

class Panel extends React.PureComponent<React.PropsWithChildren<PanelProps>, IState> {
  state: IState = {
    contentHeight: null,
    error: false
  };

  componentDidCatch() {
    this.setState({ error: true });
  }

  onResize = (contentRect) => {
    this.setState({
      contentHeight: contentRect.bounds.height
    });
  };

  panelContent = ({ measureRef }) => (<PanelContent measureRef={measureRef} contentCssClass={this.props.contentCssClass}>
    {this.props.children}
  </PanelContent>);

  public render(): JSX.Element {
    const { style, isLoading, pagination, hasError, hasData, articleId, title, subTitle, button } = this.props;
    const { contentHeight } = this.state;

    const headerSize = this.props.headerSize === "h1" ? "h1" : "h2";

    const header = ((title) || (subTitle) || (pagination) || (articleId)) && <PanelSegmentType>
      <PanelSegmentType.Header size={headerSize}>
        <PanelSegmentType.Title title={title} subTitle={subTitle} />
        {pagination && <PanelSegmentType.Pagination>{pagination}</PanelSegmentType.Pagination>}
        {articleId && <PanelSegmentType.SupportQuestionMark articleId={articleId} />}
        {button as any}
      </PanelSegmentType.Header>
    </PanelSegmentType>;

    if (this.state.error || hasError) {
      return (
        <section className={this.props.panelClassName} style={style} ref={this.props.panelRef}>
          {header}
          <PanelContent>
            <Error />
          </PanelContent>
        </section>
      );
    }

    if (hasData != null && !hasData && !isLoading) {
      return (
        <section className={this.props.panelClassName} style={style} ref={this.props.panelRef}>
          {header}
          <NoDataAvailableDiv />
        </section>
      );
    }

    return (
      <section className={this.props.panelClassName} style={style} ref={this.props.panelRef}>
        {header}
        {isLoading
          ? <Loading height={contentHeight} />
          : <Measure
            bounds
            onResize={this.onResize}>
            {this.panelContent}
          </Measure>}
      </section>
    );
  }
}

export default Panel;
